/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimelineEvent/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Appointment from './Appointment/index'
import CustomResource from './CustomResource/index'
import FutureSeparator from './FutureSeparator/index'
import No from './No/index'
import Note from './Note/index'
import Order from './Order/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TimelineEvent({
  children,
  viewPath = "/DesignSystem/TimelineEvent"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventTypeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Note'}>
<Note
  viewPath={`${viewPath}/Note`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Appointment'}>
<Appointment
  viewPath={`${viewPath}/Appointment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FutureSeparator'}>
<FutureSeparator
  viewPath={`${viewPath}/FutureSeparator`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CustomResource'}>
<CustomResource
  viewPath={`${viewPath}/CustomResource`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Order'}>
<Order
  viewPath={`${viewPath}/Order`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}